import { CoreIcon } from '../core-icon';
import locateSVG from '../../assets/icons/locate.svg';
import type { IconProps } from '../core-icon';

export const LocateIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={locateSVG} {...props} />;
};
